import { useState } from "react";
import { Form, Input, Select, Switch } from "antd";
import type { FormInstance, Rule } from "antd/es/form";
import {
  Actions,
} from "../../shared/constants";

const CompanyForm = ({
  mode,
  companyForm,
  businessTypes
}: {
  mode: string;
  companyForm: FormInstance;
  businessTypes: any[]
}) => {
  const [isActive, setIsActive] = useState<boolean>(
    mode === Actions.CREATE ? true : companyForm.getFieldValue("isActive"),
  );
  const requiredRule: Rule = { required: true, message: "Required" };

  return (
    <div className="mb-5">
      <Form.Item name="name" label={<>Name<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input size="large" placeholder={"Name"} maxLength={30} />
      </Form.Item>
      <Form.Item name="addressLine1" label={"Address Line1"} rules={[requiredRule]}>
        <Input size="large" placeholder={"Address Line1"} maxLength={200} />
      </Form.Item>
      <Form.Item name="addressLine2" label={"Address Line2"} >
        <Input size="large" placeholder={"Address Line2"} maxLength={200} />
      </Form.Item>
      <Form.Item name="email" label={<>Email<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[{ required: true, type: "email", message: "Required" }]} >
        <Input inputMode="email" size="large" placeholder="Email address" />
      </Form.Item>
      <Form.Item name="phone" label={<>Phone <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input inputMode="tel" size="large" placeholder="Phone" />
      </Form.Item>
      <Form.Item name="businessTypeId" label={<>Business Type <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Select
          className="w-full"
          placeholder={"Business type"}
          options={
            businessTypes?.map((x: any) => ({
              label: x.name,
              value: x.id,
            }))
          }
        />
      </Form.Item>
      <div className="flex justify-between">
        <div>
          <div className="form-title">
            {isActive ? "Enabled" : "Disabled"}
          </div>
          <div className="switch-extra">
            {"Visibility"}
          </div>
        </div>
        <Form.Item name="isActive" valuePropName="checked" initialValue={true}>
          <Switch
            checked={isActive}
            onChange={(checked: boolean) => {
              setIsActive(checked);
            }}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default CompanyForm;
